/**
 * @generated SignedSource<<af3d085b3c021650bbb6f851c5aba1d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutSubmitActions_viewer$data = {
  readonly default3dsAuthorizationAmountToOne: boolean | null;
  readonly disable3dsVerificationForCheckout: boolean | null;
  readonly " $fragmentType": "checkoutSubmitActions_viewer";
};
export type checkoutSubmitActions_viewer$key = {
  readonly " $data"?: checkoutSubmitActions_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutSubmitActions_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutSubmitActions_viewer"
};

(node as any).hash = "61f8724421c4a809bfc55345d4efb419";

export default node;
